import queryString from 'query-string'

export const urlParams = (url) => {
  let search = url
  if (url.indexOf('?') > -1) {
    search = url.split('?')[1]
  }

  return queryString.parse(search)
}